import { MonitoringMetricState } from '../../../../../types/DeployerControlMonitoring.types';

const stateStyles: Record<MonitoringMetricState, { badge: string; text: string; label: string }> = {
  PRESENT: { badge: 'bg-emerald-100', text: 'text-emerald-700', label: 'Present' },
  WEAK: { badge: 'bg-yellow-100', text: 'text-yellow-700', label: 'Weak' },
  MISSING: { badge: 'bg-rose-100', text: 'text-rose-700', label: 'Missing' },
  NOT_APPLICABLE: { badge: 'bg-gray-100', text: 'text-gray-500', label: 'Not Applicable' }
};

export function MetricStateBadge({ state }: { state: MonitoringMetricState }) {
  const styles = stateStyles[state];
  return (
    <div
      className={`w-min px-2.5 py-0.5 rounded-[10px] text-xs leading-4 font-medium text-nowrap ${styles.badge} ${styles.text}`}
    >
      {styles.label}
    </div>
  );
}
